import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('boundarySelectPanelField');

    return {
        FIELD_BOUNDARIES: t('fieldBoundaries'),
        NO_BOUNDARIES_FOUND: t('noBoundariesFound'),
        OTHER_BOUNDARIES: t('otherBoundaries'),
        SEARCH: t('search')
    };
};

export default useTranslation;
